import { EmailStep } from "@/features/auth/ui/login-form/email-step";
import { PasswordStep } from "@/features/auth/ui/login-form/password-step";
import { useLoginFlow } from "@/features/auth/ui/login-form/use-login-flow";

export function LoginForm() {
  const {
    step,
    email,
    password,
    error,
    loading,
    loadingSsoProviderId,
    tenantInfo,
    setEmail,
    setPassword,
    handleEmailSubmit,
    handlePasswordSubmit,
    handleSsoSignIn,
    handleBackToEmail,
  } = useLoginFlow();

  if (step === "email") {
    return (
      <EmailStep
        email={email}
        error={error}
        loading={loading}
        onEmailChange={setEmail}
        onSubmit={handleEmailSubmit}
      />
    );
  }

  return (
    <PasswordStep
      email={email}
      password={password}
      error={error}
      loading={loading}
      loadingSsoProviderId={loadingSsoProviderId}
      tenantInfo={tenantInfo}
      onPasswordChange={setPassword}
      onSubmit={handlePasswordSubmit}
      onSsoSignIn={handleSsoSignIn}
      onChangeEmail={handleBackToEmail}
    />
  );
}
